﻿// todo: needs to scope to the nearest form or possibly a data attribute the developer places so 
//       multiple instances can be used on the same page.

export class HasChanges {
  public static wireup() {
    $(document).on('change change.rustig input fileadded', function (e) {
      var $hasChanges = $('[data-has-changes]');
      if ($hasChanges.length <= 0)
        return true;

      let $this = $(this);
      if ($this.data('r-is-constructing') as boolean) {
        return true;
      }

      $hasChanges.val('true');

      return true;
    });
  }
}